import * as C from '../../constants';
import * as React from 'react';
import styled from 'styled-components';
import { Button } from './index';

const COLOR = {
  lightPurple: {
    backgroundColor: C.COLORS.lightPurple,
    color: C.COLORS.primaryColor,
    borderColor: C.COLORS.lightPurple,
  },
  moonGray: {
    backgroundColor: C.COLORS.moonGray,
    color: C.COLORS.primaryColor,
    borderColor: C.COLORS.moonGray,
  },
  red: {
    backgroundColor: C.COLORS.red,
    color: C.COLORS.white,
    borderColor: C.COLORS.red,
  },
  green: {
    backgroundColor: C.COLORS.green,
    color: C.COLORS.white,
    borderColor: C.COLORS.green,
  },
  yellow: {
    backgroundColor: C.COLORS.yellow,
    color: C.COLORS.purple,
    borderColor: C.COLORS.yellow,
  },
  purple: {
    backgroundColor: C.COLORS.purple,
    color: C.COLORS.yellow,
    borderColor: C.COLORS.purple,
  },
};

export const ColorBtn = ({ children, ...rest }) => (
  <StyledButton
    {...rest}
    style={{
      fontWeight: 'bold',
      userSelect: 'none',
      whiteSpace: 'normal',
      fontFamily: 'Source Sans Pro',
      ...COLOR[rest.color],
      ...rest.style,
    }}
  >
    {children}
  </StyledButton>
);
const StyledButton = styled(Button)`
  &:hover {
    opacity: 0.8;
  }
`;

export const PrimaryButton = styled(Button)`
  background-image: linear-gradient(
    to right,
    ${C.COLORS.primaryColor2},
    ${C.COLORS.midPrimaryColor}
  ) !important;
  border-color: ${C.COLORS.primaryColor2} !important;
  border-radius: 17px;
  color: ${C.COLORS.white};
`;

export const LightButton = styled(Button)`
  border-radius: 17px;
  background-color: ${C.COLORS.lightPrimaryColor} !important;
  color: ${C.COLORS.neonPrimaryColor};
  &:hover {
    color: ${C.COLORS.primaryColor};
  }
`;



// WEBPACK FOOTER //
// ./app/components/antd/Buttons.tsx